const intersection = require('lodash/intersection');

window.addEventListener( 'alpine:init', bootstrap );

export default () => ({
	cards: [],
	filter_criteria: { },
	search_value: '',
	filter_keys: [],
	no_results_message: 'No results found',
	masonry_layout: false,
	view_page: 1,
	cards_per_page: 12,
	ready: false,
	filtered_cards: [],
	init() {
		// TODO update check to support masonry options
		this.masonry_layout = this.$refs?.loop?.hasAttribute('x-masonry');
		this.no_results_message = this.$refs?.no_results_message?.textContent ?? '';
		this.filter_keys = JSON.parse(
			this.$refs?.filter_keys?.textContent ?? '[]'
		);
		this.setupCards();
		this.filtered_cards = this.cards;
		this.maybeReflowMasonry();
		this.$nextTick( () => { this.ready = true; } );
	},
	search() {
		this.search_value = this.$event.detail.toLowerCase();

		// Reset page on search change to avoid getting stuck on deep page
		this.view_page = 1;

		this.filtered_cards = this.filterCards();
	},
	filter() {
		const key = this.$event.detail.key;
		if ( !this.filter_keys.includes(key) ) { return; }

		const value = this.$event.detail.value;
		const delete_key = typeof value === 'object' ? value.length === 0 : value == '';
		if ( delete_key ) {
			delete this.filter_criteria[key];
		} else {
			this.filter_criteria[key] = this.$event.detail.value;
		}

		// Reset page on filter change to avoid getting stuck on deep page
		this.view_page = 1;

		this.filtered_cards = this.filterCards();
	},
	get active_filters() {
		return ((Object.keys(this.filter_criteria)).length > 0)
			|| (this.search_value.length > 0)
		;
	},
	maybeReflowMasonry() {
		if ( this.masonry_layout ) {
			this.$nextTick( () => this.$dispatch('reload:masonry') );
		}
	},
	setupCards() {
		this.cards = Array.from(this.$refs.loop.children)
			.filter( el => el.tagName === 'DIV' )
			.map( el => {
				const klass = el.getAttribute('class');
				const klass_list = Array.from(el.classList);
				let entry = {
					class: klass,
					content: el.innerHTML.replace(' skeleton"', '"'),
				};

				this.filter_keys.forEach( key => {
					const prefix = `${key}-`;
					entry[key] = klass_list
						.filter( _ => _.startsWith(prefix) )
						.map( _ => _.substr(prefix.length) )
					;
				} );

				let search_bits = [];
				const search_text_selectors = [
					'.c-card__title',
					'.c-card__content',
				];
				search_text_selectors.forEach( selector => {
					const $$ = el.querySelector(selector);
					if ( $$ ) { search_bits.push( $$.innerText ); }
				} );
				entry.search_text = search_bits.join(' ').toLowerCase();

				el.remove();
				return entry;
			} )
		;
	},
	filterCards() {
		if ( !this.ready ) { return this.cards; }

		let cards = this.cards;

		(Object.keys(this.filter_criteria)).forEach(key => {
			const value = this.filter_criteria[key];
			if ( typeof value === 'object' ) {
				cards = cards.filter(_ => intersection(_[key], value).length > 0 );
			} else {
				cards = cards.filter(_ => _[key].includes(value));
			}
		});

		if ( this.search_value ) {
			cards = cards.filter(_ => _.search_text.includes(this.search_value) );
		}

		this.filter_keys.forEach(key => {
			this.$dispatch(
				'available-options',
				{
					key: key,
					options: [...new Set(cards.flatMap(_ => _[key]))]
				}
			);
		});

		return cards;
	},
	get paginated_cards() {
		this.maybeReflowMasonry();
		return this.filtered_cards.slice(
			(this.view_page - 1) * this.cards_per_page,
			this.view_page * this.cards_per_page
		);
	},
	get page_count() {
		return Math.ceil(this.filtered_cards.length / this.cards_per_page);
	},
	get page_links() {
		let links = [];
		let dots = false;
		const end_size = 1, mid_size = 2;
		for ( let n = 1; n<=this.page_count; n++ ) {
			if ( n === this.view_page ) {
				links.push( { page: n, text: n } );
			} else {
				if (
					n <= end_size
					|| n > this.page_count - end_size
					|| (
						this.view_page
						&& n >= this.view_page - mid_size
						&& n <= this.view_page + mid_size
					)
				) {
					links.push( { page: n, text: n });
					dots = true;
				} else if ( dots ) {
					links.push( { page: -1, dots: true, text: '...' } );
					dots = false;
				}
			}
		}

		return links;
	},
	get has_next_page() {
		return this.view_page < this.page_count;
	},
	get has_prev_page() {
		return this.view_page > 1;
	},
	nextPage() {
		if ( !this.has_next_page ) { return; }
		this.view_page++;
	},
	prevPage() {
		if ( !this.has_prev_page ) { return; }
		this.view_page--;
	},
	goToPage(num) {
		this.view_page = num;
	}
});

function bootstrap() {
	document.querySelectorAll('.js-alpine-post-cards')
		.forEach( $el => bootstrapPostCards($el) )
	;
}

function bootstrapPostCards($el) {
	const $root = $el;
	const $loop = $el.querySelector('.wpex-post-cards-loop');

	$root.setAttribute('x-data', 'postCards');
	$root.setAttribute('x-on:filter.window', 'filter');
	$root.setAttribute('x-on:search.window', 'search');
	$loop.setAttribute('x-ref', 'loop');
	if ( $el.classList.contains('js-alpine-masonry') ) {
		// $loop.setAttribute('x-data', '');
		$loop.setAttribute('x-masonry', '');
	}
	$root.insertAdjacentHTML(
		'afterbegin',
		'<p class="no-results-message" x-text="no_results_message" x-show="filtered_cards.length === 0" />'
	);

	if ( $el.classList.contains('js-alpine-clear-filters-control') ) {
		$root.insertAdjacentHTML(
			'afterbegin',
			`
<button type="button" class="c-button--clear-filters" @click="$dispatch('clear-filters')" x-show="active_filters">
	<span>Clear Filters</span>
	<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
	  <rect x="8.69531" width="1.84462" height="12.2975" transform="rotate(45 8.69531 0)" fill="#61366E"/>
	  <rect x="10" y="8.69531" width="1.84462" height="12.2975" transform="rotate(135 10 8.69531)" fill="#61366E"/>
	</svg>
</button>
`
		);
	}

	let loop_source = 'filtered_cards';
	if ( $el.classList.contains('js-alpine-paginated') ) {
		loop_source = 'paginated_cards';

		$root.insertAdjacentHTML(
			'beforeend',
			`
<nav class="c-pagination-nav">
	<div class="prev-link" :class="{ 'disabled': !has_prev_page }" x-on:click="prevPage">
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
		  <path fill-rule="evenodd" clip-rule="evenodd" d="M10.2329 4.18414C10.4626 4.423 10.4551 4.80282 10.2163 5.0325L7.06605 8L10.2163 10.9675C10.4551 11.1972 10.4626 11.577 10.2329 11.8159C10.0032 12.0547 9.62339 12.0622 9.38452 11.8325L5.78452 8.4325C5.66688 8.31938 5.60039 8.16321 5.60039 8C5.60039 7.83679 5.66688 7.68062 5.78452 7.5675L9.38452 4.1675C9.62339 3.93782 10.0032 3.94527 10.2329 4.18414Z" fill="#333333"/>
		</svg>
	</div>
	<div class="c-pagination-nav__page-links">
		<template x-for="link in page_links">
			<span class="page-link" :class="{ 'is-active': link.page===view_page, 'is-dots': link.dots }" x-text="link.text" x-on:click="goToPage(link.page)"></span>
		</template>
	</div>
	<div class="next-link" :class="{ 'disabled': !has_next_page }" x-on:click="nextPage">
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
		  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.76711 11.8159C5.53743 11.577 5.54488 11.1972 5.78374 10.9675L8.93395 8L5.78374 5.0325C5.54488 4.80282 5.53743 4.423 5.76711 4.18413C5.99679 3.94527 6.37661 3.93782 6.61548 4.1675L10.2155 7.5675C10.3331 7.68062 10.3996 7.83679 10.3996 8C10.3996 8.16321 10.3331 8.31938 10.2155 8.4325L6.61548 11.8325C6.37661 12.0622 5.99679 12.0547 5.76711 11.8159Z" fill="#333333"/>
		</svg>
	</div>
`
		);
	}
	$loop.insertAdjacentHTML(
		'afterbegin',
		`<template x-for="card in ${loop_source}"><div :class="card.class" x-html="card.content"></div></template>`
	);

}

